import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, omit } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";
import { Button } from "kea-react";

interface DatosCredito extends models.DatosCredito {
    IdDatosCreditoColonia: number | null;
    IdSucursalCobranza: number | null;
    AbonosCredito: number;
    CargosCredito: number;
    SaldoCredito: number;
}

type Entity = DatosCredito;

function mapValue(x: models.ClienteDTO): DatosCredito {
    return {
        ... (x.DatosCredito || {}),
        IdDatosCreditoColonia: x.IdDatosCreditoColonia,
        IdSucursalCobranza: x.IdSucursalCobranza,
        AbonosCredito: x.AbonosCredito,
        CargosCredito: x.CargosCredito,
        SaldoCredito: x.SaldoCredito,
    }
}

function mapChange(change: DatosCredito, x: models.ClienteDTO): models.ClienteDTO {
    return {
        ...x,
        DatosCredito: omit(change, ["IdDatosCreditoColonia"]),
        IdDatosCreditoColonia: change.IdDatosCreditoColonia,
        IdSucursalCobranza: change.IdSucursalCobranza,
    };
}

interface CompProps {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    readonly?: boolean;
}

/**
* Valida un Entity
*/
function validar(x: Entity) {
    const requeridoSiLimiteCredito = (value: DatosCredito, key: keyof DatosCredito) => (x.LimiteCredito != null && x.LimiteCredito > 0 && x[key] == null) ? "Requerido si se establece el límite de crédito" : true;

    const rules: validation.Rules<Entity> = {
        DiaRevision: requeridoSiLimiteCredito,
        DiaCobranza: requeridoSiLimiteCredito,
        DiasCredito: requeridoSiLimiteCredito,
        FormaPago: requeridoSiLimiteCredito,
        LimiteCredito: validation.range(0),
        DireccionCobranza: (x, key) => x.LimiteCredito ? (x.IdDatosCreditoColonia == null ? "Requerido si se establece limite de crédito" : true) : true,
        IdSucursalCobranza: requeridoSiLimiteCredito,
    };
    return validation.getErrors(rules, x);
}

const DireccionColonia = obtenerComponenteDireccionColonia<DatosCredito>("IdDatosCreditoColonia", "DireccionCobranza", "Direccion de cobranza");

/**
* Componente para editar un DatosCredito
*/
class DatosCreditoEditComponent extends React.PureComponent<CompProps> {
    value = (props: CompProps) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const errors = this.errors(this.props);

        const Number = getField(kea.Number);
        const DiaSemana = getField(selectores.DiaSemana);
        const Sucursal = getField(selectores.Sucursal);
        const FormaPago = getField(selectores.FormaPago);
        const SiNo = getField(selectores.SiNo);

        const FormaPagoSat = getField(selectores.ClaveFormaPagoSat);
        const MetodoPagoSat = getField(selectores.ClaveMetodoPagoSat);
        return (
            <div> 
               
                    {kea.autogrid(3, [
                        <Number field="SaldoCredito" label="Saldo crédito" format="currency" readonly />,
                        <Number field="CargosCredito" label="Cargos crédito" format="currency" readonly />,
                        <Number field="AbonosCredito" label="Abonos crédito" format="currency" readonly />,
                    ])}

                    {kea.autogrid(3, [
                        <Number field="LimiteCredito" label="Límite de crédito" format="currency" />,
                        <SiNo field="CreditoBloqueado" label="Bloquear linea de crédito" />,
                        <Number field="DiasCredito" label="Dias de crédito" format="int" />,
                        <DiaSemana field="DiaRevision" label="Dia de revisión" />,
                        <DiaSemana field="DiaCobranza" label="Dia de cobranza" />,
                        <FormaPago field="FormaPago" label="Forma de pago de cobranza" />,
                        <Sucursal field="IdSucursalCobranza" label="Sucursal de cobranza" />,
                    ])}
                    <DireccionColonia value={value} onChange={this.props.onChange} error={errors.DireccionCobranza} /> 
            </div>);
    }
}

export async function validarDatosCredito(x: models.ClienteDTO): Promise<string | true> {
    return (await validation.hasError(validar(mapValue(x)))) ? "Datos erroneos" : true;
}

export interface Props {
    value: models.ClienteDTO;
    onChange: (x: models.ClienteDTO) => void;
    readonly?: boolean;
}

/**Edita los datos de crédito de un cliente */
export class DatosCreditoComp extends React.PureComponent<Props> {

    onCopiar = () => {
        //1.- Obtener nuevoValue:
        const value = this.props.value;
        var direccion = value.DireccionFacturacion; 
        if(direccion=== undefined){
            direccion=  {
            Calle: "",
            NoExterior: "",
            NoInterior: "", 
            IdColonia: 0,
            IdCiudad: 0,
            IdMunicipio: 0,
            IdEstado: 0, 
            NombreColonia: "",
            CodigoPostal: 0,
            NombreCiudad: "",
            NombreMunicipio: "",
            NombreEstado: "",
            Descripcion: "",
            Telefono: "",
            Email : ""
            }
        }
        direccion.Calle= value.DatosFacturacion.Direccion.Calle;
        direccion.NoExterior= value.DatosFacturacion.Direccion.NoExterior;
        direccion.NoInterior= value.DatosFacturacion.Direccion.NoInterior == undefined?"": value.DatosFacturacion.Direccion.NoInterior;
        direccion.Telefono = value.DatosFacturacion.Direccion.Telefono;
        direccion.Email = value.DatosFacturacion.Direccion.Email;
        const idColonia = value.IdDatosFacturacionColonia;
        const nuevoValue = cambiarDireccionFiscal(value, direccion, idColonia ); 
        //2.- Lamar al onChange
        this.props.onChange(nuevoValue);
    }
    onChange = (x: DatosCredito) => {
        this.props.onChange(mapChange(x, this.props.value));
    }
    render() { 
        const value = mapValue(this.props.value);
        return ( 
            <div> 
            <kea.Panel title="Datos de crédito y cobranza" style="success"> 
                <Button onClick={this.onCopiar} >
                    Copiar direccion de facturación
                </Button>
                <DatosCreditoEditComponent value={value} onChange={this.onChange} readonly={this.props.readonly} />
            </kea.Panel>
            </div> );
    }
}

/**
 * Devuelve un nuevo obj de tipo cliente con la direccion nueva de cobranza  cambiada (no modifica el cliente "old")
 */
function cambiarDireccionFiscal(old: models.ClienteDTO, direccion: models.Direccion, idColonia: number | null): models.ClienteDTO {
    //DatosFacturacion.Direccion  
     return {
        ... old,
        IdDatosCreditoColonia: idColonia,
        DatosCredito: {
            ... old.DatosCredito,
            DireccionCobranza: direccion
        }
    };
 }


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/datoscredito/datoscredito.tsx